import ListItem from "@mui/material/ListItem";
import { styled } from "@mui/material/styles";
import _ from "lodash";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { black, grey } from "designSystem/styles/color";
import { CSS_ANCHOR_RESET } from "designSystem/styles/style-functions";
import Text from "../text/Text";
import { ACTIVE_NOT_SELECTED, HOVER_NOT_SELECTED, SELECTED } from "designSystem/theme";
import { StepInfo } from "./WizardDialog";
import WizardStore from "./WizardStore";

export interface StepItemProps {
	/** the index of the step */
	stepIndex: number;

	/** store to which this component reacts */
	store: WizardStore;
}

const PREFIX = "StepListItem";
const classes = {
	currentStep: `${PREFIX}currentStep`,
	futureStep: `${PREFIX}futureStep`,
	previousStep: `${PREFIX}previousStep`,
};

const StepListItem = styled(ListItem)(({ theme }) => ({
	borderWidth: 3,
	borderRightStyle: "solid",
	color: black[100],
	paddingLeft: 24,
	display: "block",
	[`&.${classes.currentStep}`]: {
		[SELECTED]: {
			backgroundColor: theme.palette.NavListItemSelectedBG,
			borderColor: theme.palette.PrimaryDefault,
			color: black[100],
		},
	},
	[`&.${classes.futureStep}`]: {

	},
	[`&.${classes.previousStep}`]: {
		[HOVER_NOT_SELECTED]: {
			backgroundColor: grey[200],
			borderColor: grey[500],
		},
		[ACTIVE_NOT_SELECTED]: {
			backgroundColor: theme.palette.NavListItemSelectedBG,
			borderColor: theme.palette.PrimaryDefault,
		},
	},
}));

const StepItem: FunctionComponent<StepItemProps> = observer((props) => {
	const {
		stepIndex,
		store,
	} = props;

	const {
		index,
		previousPage,
		stepInfoList,
	} = store;

	const {
		currentStep,
		previousStep,
		futureStep,
	} = classes;

	const {
		title,
		subtitle,
		values,
	} = stepInfoList[stepIndex] || {} as StepInfo;

	const isCurrentStep = stepIndex == index;
	const isPreviousStep = stepIndex < index;
	const isFutureStep = stepIndex > index;
	const finalClass = isCurrentStep ? currentStep : (isPreviousStep ? previousStep : futureStep);

	return (
		<StepListItem
			className={`${CSS_ANCHOR_RESET} ${finalClass}`}
			disabled={isFutureStep}
			onClick={isPreviousStep ? (event) => previousPage(stepIndex) : (event) => null}
			selected={isCurrentStep}
		>
			<Text
				block
				bold
				style={{ marginBottom: 8 }}
				text={title}
			/>
			{!_.isEmpty(values) &&
				values.map((value, j) => (
					<Text
						block
						key={`step${stepIndex}_value${j}`}
						style={{ marginBottom: 12 }}
						text={value}
					/>
				))
			}
			{_.isEmpty(values) && (
				<Text
					text={subtitle}
				/>
			)}
		</StepListItem>
	);
});

export default StepItem;